import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  class: "jl2-custom-filled-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.9819 16.8188L16.0076 18.7932L14.0332 16.8188",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.0078 12V18.7933",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M23.8012 12V19.7545C23.8012 21.0664 22.7361 22.1316 21.4242 22.1316H10.5782C9.26628 22.1316 8.20117 21.0664 8.20117 19.7545V12",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 31C24.28 31 31 24.28 31 16C31 7.72 24.28 1 16 1C7.72 1 1 7.72 1 16C1 24.28 7.72 31 16 31Z",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ])))
}